/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { Form } from "antd";
import { ValidateStatus } from "antd/es/form/FormItem";
import { ReactNode } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

import { InputPhoneNumberStyle } from "./index.style";
interface SelectCustomProps {
  name: string;
  control: Control<FieldValues | any>;
  error?: string;
  validate_status?: ValidateStatus;
  value?: string;
  disabled?: boolean;
  margin_bottom?: string;
  prefix?: ReactNode;
}

const InputPhoneNumber = (props: SelectCustomProps) => {
  const { t } = useTranslation("placeholder");
  const { control, error, validate_status, margin_bottom, prefix } = props;
  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <Form.Item
        css={[
          {
            marginBottom: margin_bottom ? margin_bottom : "0px",
            width: "100%",
          },
          InputPhoneNumberStyle.self,
        ]}
        help={error}
        validateStatus={validate_status}
      >
        <div css={InputPhoneNumberStyle.inputContainer}>
          <Controller
            name={props.name}
            control={control}
            render={({ field }) => {
              return (
                <div
                  css={css`
                    display: flex;
                    align-items: center;
                    width: 100%;
                  `}
                >
                  <PhoneInput
                    {...field}
                    // countries={["MY"]}
                    defaultCountry={"BD"}
                    limitMaxLength={true}
                    countries={["MY", "BD"]}
                    international={false}
                    flags={flags}
                    id={props.name}
                    hasUserSelectedACountry
                    countryOptionsOrder={["MY", "BD"]}
                    disabled={props.disabled}
                    smartCaret={false}
                    css={InputPhoneNumberStyle.inputPhoneNumber}
                    numberInputProps={{
                      placeholder: t("PhoneNumber"),
                    }}
                  />
                  {prefix}
                </div>
              );
            }}
          />
        </div>
      </Form.Item>
    </div>
  );
};

export default InputPhoneNumber;
